import { z } from "zod";
import isNil from "../validation/isNil";

const schema = z.object({
  url: z.string().url(),
  geocodingProvider: z.enum(["fake", "nominatim"]).default("fake"),
});

let _appConfiguration: z.infer<typeof schema>;

export const appConfiguration = () => {
  if (isNil(_appConfiguration)) {
    _appConfiguration = schema.parse({
      url: process.env.URL,
      geocodingProvider: process.env.GEOCODING_PROVIDER,
    });
  }

  return _appConfiguration;
};
